"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.col.model': 'Modello',
    'dblogs.col.operation': 'Operazione',
    'dblogs.col.recordId': 'ID record',
    'dblogs.col.date': 'Data',
    'dblogs.col.payload': 'Dati',
    'dblogs.col.result': 'Risultato',
};
